<template>
  <div :id="componentId" class="spm1-carousel" :style="{ backgroundColor }">
    <div
      class="spm1-carousel-track"
      :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
    >
      <div
        v-for="(banner, idx) in banners"
        :key="idx"
        class="spm1-carousel-slide"
        :style="{ backgroundColor: banner.backgroundColor }"
      >
        <a
          v-if="banner.jumpType === 1"
          class="spm1-slide-link"
          href="javascript:;"
          @click.prevent="handleAnchor(banner.jumpContent)"
        >
          <img class="spm1-slide-image" referrerpolicy="no-referrer" :src="banner.imageUrl" />
        </a>
        <a
          v-else-if="banner.jumpType === 3"
          class="spm1-slide-link"
          :href="banner.jumpContent"
          target="_blank"
        >
          <img class="spm1-slide-image" referrerpolicy="no-referrer" :src="banner.imageUrl" />
        </a>
        <div v-else class="spm1-slide-static">
          <img class="spm1-slide-image" referrerpolicy="no-referrer" :src="banner.imageUrl" />
        </div>
      </div>
    </div>
    <div class="spm1-carousel-dots">
      <span
        v-for="(banner, idx) in banners"
        :key="idx"
        :class="['spm1-carousel-dot', { active: currentIndex === idx }]"
        @click.stop="goToSlide(idx)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileHeroCarousel',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_2'
    }
  },
  data() {
    return {
      currentIndex: 0,
      timer: null,
      autoPlayInterval: 3000,
      backgroundColor: 'rgba(255, 255, 255, 1)',
      banners: [
        {
          backgroundColor: 'rgba(245, 245, 245, 1)',
          imageUrl: require('../../../special/SpecialOne/assets/img/banner_01.png'),
          jumpType: 1,
          jumpContent: 'module_4'
        },
        {
          backgroundColor: 'rgba(232, 244, 242, 1)',
          imageUrl: require('../../../special/SpecialOne/assets/img/banner_01.png'),
          jumpType: 2,
          jumpContent: ''
        },
        {
          backgroundColor: 'rgba(255, 248, 240, 1)',
          imageUrl: require('../../../special/SpecialOne/assets/img/banner_01.png'),
          jumpType: 3,
          jumpContent: 'https://www.example.com'
        }
      ]
    }
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    startAutoPlay() {
      this.stopAutoPlay()
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.banners.length
      }, this.autoPlayInterval)
    },
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    goToSlide(idx) {
      this.currentIndex = idx
      this.stopAutoPlay()
      this.startAutoPlay()
    },
    handleAnchor(anchor) {
      if (!anchor) return
      const el = document.getElementById(anchor)
      if (!el) return
      const headerOffset = 48
      const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset
      window.scrollTo({ top, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.spm1-carousel {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.spm1-carousel-track {
  display: flex;
  width: 100%;
  transition: transform 0.5s ease;
}

.spm1-carousel-slide {
  flex: 0 0 100%;
  width: 100%;
}

.spm1-slide-link,
.spm1-slide-static {
  display: block;
  width: 100%;
}

.spm1-slide-link {
  cursor: pointer;
}

.spm1-slide-image {
  width: 100%;
  height: auto;
  display: block;
}

.spm1-carousel-dots {
  position: absolute;
  bottom: 8px;
  left: 50%;
  z-index: 2;
  display: flex;
  gap: 4px;
  transform: translateX(-50%);
}

.spm1-carousel-dot {
  width: 14px;
  height: 4px;
  background: rgba(216, 216, 216, 1);
  border-radius: 3px;
  cursor: pointer;
  transition: background 0.3s;
}

.spm1-carousel-dot.active {
  background: #A00000;
}
</style>
